import { MoDataStore } from "ui-common";
import { SiteStoreMockPlugin } from "./mocks/SiteStoreMockPlugin";

export class SiteEnvironmentStore extends MoDataStore {
  static readonly defaultConfig = {
    mockPlugin: SiteStoreMockPlugin,

    api: {
      service: 'sites',
      list: 'getSiteEnvironments',
      get: 'getSiteEnvironment',
    },
  };

  async getSiteEnvironments(customerId: string, siteId: string) {
    const mocks = new SiteStoreMockPlugin({} as any)
    if (this.config.mock) {
      return mocks.getEnvironments(customerId, siteId);
    }
    try {
      const sites = await this.callApiMethod({
        service: 'sites',
        name: 'getSiteEnvironments',
        pathParams: { customerId, siteId },
      }, {});
      return sites?.content || [];
    } catch {
      return [];
    }
  }
}